module.exports = __webpack_public_path__ + "img/seccionA.3ce8b17d.jpg";